function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import Graph from '../multiOccurrenceGraph';
import { getRandomId } from '../util';

var MultiOccurrenceGraph = function MultiOccurrenceGraph(props) {
  var width = props.width,
      maxHeight = props.maxHeight,
      healthEntryValues = props.healthEntryValues,
      generalErrorMessage = props.generalErrorMessage,
      naUnits = props.naUnits,
      compositeUnits = props.compositeUnits,
      locale = props.locale,
      p1dFormatter = props.p1dFormatter,
      p1mFormatter = props.p1mFormatter,
      p1yFormatter = props.p1yFormatter;
  var svg = React.useRef(null);
  var container = React.useRef(null);

  var _React$useState = React.useState(function () {
    return getRandomId();
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      id = _React$useState2[0];

  var graph = new Graph(id, width, maxHeight, healthEntryValues, naUnits, compositeUnits, locale);
  graph.setDateFormatters(p1dFormatter, p1mFormatter, p1yFormatter);
  var hash = graph.hash();
  React.useEffect(function () {
    var svgElement;

    try {
      svgElement = graph.createSVG();
      container.current.style.height = "".concat(maxHeight, "px");
    } catch (err) {
      var errorNode = document.createElement('div');
      errorNode.className = 'error';
      errorNode.innerHTML = generalErrorMessage;
      svgElement = errorNode;
    }

    if (svg.current.firstElementChild) {
      svg.current.replaceChild(svgElement, svg.current.firstElementChild);
    } else {
      svg.current.appendChild(svgElement);
    }
  }, [hash]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: container
  }, /*#__PURE__*/React.createElement("style", null, "\n          #".concat(id, " svg text {\n            -webkit-user-select: none;\n            -moz-user-select: none;\n            -ms-user-select: none;\n            user-select: none;\n          }\n          #").concat(id, " .transparent {\n            fill: transparent !important;\n          }\n          #").concat(id, " {\n            width: ").concat(width, "px;\n            font-family: 'GT America','helvetica neue',helvetica,arial,sans-serif;\n          }\n          #").concat(id, " .error {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            text-align: center;\n            font-size: 15px;\n            color: #646464;\n          }\n        ")), /*#__PURE__*/React.createElement("div", {
    ref: svg
  }));
};

export default MultiOccurrenceGraph;